<template>
  <div id="user-edit-tab-info">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="data.avatar" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data.name }}</p>
            <input
              type="file"
              class="hidden"
              ref="update_avatar_input"
              @change="update_avatar"
              accept="image/*"
            />

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mr-4 mb-4">Change Avatar</vs-button>
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <vs-button type="border" color="danger">Remove Avatar</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">

        <vs-input
          class="w-full mt-4"
          label="Name"
          v-model="data_local.name"
          v-validate="'required|alpha_spaces'"
          name="name"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!--<label class="vs-input&#45;&#45;label">Email Status</label>
        <v-select
          v-model="status_local"
          :clearable="false"
          :options="statusOptions"
          v-validate="'required'"
          name="status"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('status')"
        >{{ errors.first('status') }}</span>-->

      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <vs-input
            class="w-full mt-4"
            label="Email"
            v-model="data_local.email"
            type="email"
            v-validate="'required|email'"
            name="email"
            disabled
          />
          <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

        </div>

        <!--<div class="mt-4">
          <label class="vs-input&#45;&#45;label">Role</label>
          <v-select
            v-model="role_local"
            :clearable="false"
            :options="roleOptions"
            v-validate="'required'"
            name="role"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-danger text-sm" v-show="errors.has('role')">{{ errors.first('role') }}</span>
        </div>-->
      </div>
    </div>

    <!-- Permissions -->
    <vx-card class="mt-base" no-shadow card-border>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Preferences</span>
          </div>
          <vs-divider />
        </div>
      </div>

      <div class="block overflow-x-auto">
        <vs-row>
          <vs-col vs-type="flex" vs-w="6">
            <div class="mb-4">
              <h6 class="mb-4">Email Preference</h6>

              <div class="flex items-center mb-4">
                <vs-switch v-model="data_local.email_service_request" />
                <span class="ml-4">Service Requests</span>
              </div>
              <div class="flex items-center mb-4">
                <vs-switch v-model="data_local.email_quote" />
                <span class="ml-4">Quotes</span>
              </div>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6">
            <div class="mb-4">
              <h6 class="mb-4">Notification preferences</h6>

              <div class="flex items-center mb-4">
                <vs-switch v-model="data_local.notify_quote" />
                <span class="ml-4">Quotes</span>
              </div>
              <div class="flex items-center mb-4">
                <vs-switch v-model="data_local.notify_message" />
                <span class="ml-4">Chat Messages</span>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="save_changes"
            :disabled="!validateForm"
          >Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data))

      /*statusOptions: [
        { label: "Verified", value: "Verified" },
        { label: "Not Verified", value: "Not Verified" }
      ],
      roleOptions: [
        { label: "Vendor", value: "vendor" },
        { label: "unassigned", value: "unassigned" },
        { label: "Partner", value: "partner" },
        { label: "Promoter", value: "promoter" },
        { label: "Support Staff", value: "staff" },
        { label: "Admin", value: "admin" }
      ]*/
    }
  },
  computed: {
    /*status_local: {
      get () {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status
        }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role
        }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },*/
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$store
        .dispatch("userManagement/updateUser", {
          id : this.data_local.id,
          role : 'unassigned',
          name : this.data_local.name,
          email_service_request : this.data_local.email_service_request,
          email_quote : this.data_local.email_quote,
          notify_quote : this.data_local.notify_quote,
          notify_message : this.data_local.notify_message
        })
        .then((res) => {
          this.data_local = res.data.data
          this.$vs.notify({
            color: "success",
            title: "User Updated",
            text: "The user was successfully updated"
          })
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
      /* eslint-enable */
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
